import { render, staticRenderFns } from "./SingularityMediaUploadDialog.vue?vue&type=template&id=54cb1958&"
import script from "./SingularityMediaUploadDialog.vue?vue&type=script&lang=ts&"
export * from "./SingularityMediaUploadDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports